<template>
  <div
    class="flex w-full justify-between items-center px-4 py-4 border border-x-0 border-t-0 border-b-1 border-prime-golden-400 bg-pitch-black-900"
  >
    <!-- Project/Contacts Count or Search Bar -->
    <div>
      <h1 v-if="!showSearch" class="text-2xl font-semibold text-total-white">
        {{ props.title || "Projects" }}
        <span class="text-xl">({{ props.count ?? "..." }})</span>
      </h1>
      <div v-else class="mt-1 p-1">
        <input
          type="text"
          v-model="searchQuery"
          @input="searchProjects"
          class="w-full min-w-[80vw] bg-pitch-black-900 outline-none text-total-white"
          placeholder="Search..."
        />
      </div>
    </div>

    <!-- Icons Section -->
    <div class="flex items-center space-x-5">
      <!-- Add Icon -->
      <button v-if="routeName != 'CreateActivationPage' && !showSearch" @click="navigateToAddPage" class="text-prime-golden">
        <img src="../assets/images/add-icon.svg" width="20" height="20" />
      </button>

      <!-- Search Icon -->
      <button v-if="!showSearch" @click="toggleSearch" class="text-prime-golden">
        <img src="@/assets/images/search.svg" width="20" height="20" />
      </button>

      <!-- Close Search Icon -->
      <button v-else @click="toggleSearch" class="text-prime-golden">
        <div class="bg-gray-500 rounded-full w-4 h-4 flex items-center justify-center">
          <i class="fas fa-times text-xs text-black"></i>
        </div>
      </button>

      <!-- Filter Icon Button -->
      <button v-if="!showSearch && props.hasFilter" @click="props.toggleFilter">
        <img
          v-if="!props.filterApplied"
          class="w-6 h-6"
          src="../assets/images/bars-filter.svg"
        />
        <img
          v-if="props.filterApplied"
          class="w-6 h-6"
          src="../assets/images/bars-filter-inverted.svg"
        />
      </button>
    </div>
  </div>
</template>

<script setup>
import { ref, computed, defineEmits, defineProps } from "vue";
import { useRouter } from "vue-router";

// Define props using defineProps without destructuring to maintain reactivity
const props = defineProps({
  title: {
    type: String,
    required: true,
  },
  count: {
    type: Number,
    required: true,
  },
  routeName: {
    type: String, // Accept the dynamic route name
    required: true,
  },
  hasFilter: {
    type: Boolean,
    required: true,
  },
  toggleFilter: {
    type: Function,
    required: true,
  },
  filterApplied: {
    type: Boolean,
    required: true,
  },
});

const showSearch = ref(false);
const searchQuery = ref("");

const router = useRouter();

const emit = defineEmits(["search"]);

const toggleSearch = () => {
  showSearch.value = !showSearch.value;
  if (!showSearch.value) {
    searchQuery.value = "";
    searchProjects();
  }
};

const searchProjects = () => {
  emit("search", searchQuery.value, showSearch);
};
const navigateToAddPage = () => {
  // Navigate dynamically based on the routeName prop
  router.push({ name: props.routeName });
};
</script>
